export enum RulesetEnum {
    'Ruleset1_PD' = 'Ruleset1_PD',
    'Ruleset1_PD_GV' = 'Ruleset1_PD_GV',
    'Ruleset1_PD_QCV' = 'Ruleset1_PD_QCV',
    'Ruleset1_PD_GV_3W_MD' = 'Ruleset1_PD_GV_3W_MD',
    'Ruleset1_PD_GV_3W_CO' = 'Ruleset1_PD_GV_3W_CO',
    'Ruleset1_PD_OCCO' = 'Ruleset1_PD_OCCO',
    'Ruleset4_PIQCV' = 'Ruleset4_PIQCV',
    'Ruleset5_PD_6W' = 'Ruleset5_PD_6W',
    'Ruleset5_PD_6W_OCCO' = 'Ruleset5_PD_6W_OCCO',
    'Ruleset6_PI_6W_EPIV' = 'Ruleset6_PI_6W_EPIV',
    'Ruleset6_PI_6W_QCV' = 'Ruleset6_PI_6W_QCV',
    'Ruleset100_PIFLV' = 'Ruleset100_PIFLV',
    'Ruleset3_PI_EV_EPIV' = 'Ruleset3_PI_EV_EPIV',

    'AM_PD' = 'AM_PD',
    'AM_PD_6W_CCV' = 'AM_PD_6W_CCV',
    'AM_PD_BFV' = 'AM_PD_BFV',
    'AM_PD_BFV_OC' = 'AM_PD_BFV_OC',
    'AM_PD_QCV' = 'AM_PD_QCV',
    'AM_PI' = 'AM_PI',
    'AM_PI_6W' = 'AM_PI_6W',
}

